import clsx from "clsx";

import { Tab, TabHeader } from "@transfr-inc/dashboard-components";

export const getProductTabComponent = (
  product,
  tabContentComponent,
  overrides
) => {
  const { headerText, headerClassName, contentClassName } = overrides || {};

  return {
    name: product.id,
    header: (
      <TabHeader
        name={product.id}
        className={clsx(headerClassName, `${product.name}-tab-header`)}
      >
        {headerText || product.name}
      </TabHeader>
    ),
    content: (
      <Tab name={product.id} className={contentClassName}>
        {tabContentComponent}
      </Tab>
    ),
  };
};
